export default {
  label: 'Sorting',
  items: {
    asc: 'Ascending',
    desc: 'Descending',
  },
};
